import * as types from '@store/action-types';
import { OnboardingCompletedAction, OnboardingCompletedState } from '@store/interfaces';

export const onboardingCompleted = (data: OnboardingCompletedState): OnboardingCompletedAction => {
  return {
    type: types.ONBOARDING_COMPLETED,
    ...data,
  };
};